/**
 * Printed terms handed over instead of a digital acceptance — read-only.
 * Deliberately worded so it can't be mistaken for an acceptance: the customer
 * was given the terms on paper; they did not agree to them on a device.
 */

import React from 'react';
import type { CheckInTermsNotice } from '@techgitter/contracts';

export interface CheckInTermsNoticeSectionProps {
  notice: CheckInTermsNotice;
}

const fmt = (iso: string): string => {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleString('en-AU', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
};

export const CheckInTermsNoticeSection: React.FC<CheckInTermsNoticeSectionProps> = ({ notice }) => (
  <div className="ci-section">
    <div className="ci-awaiting">Terms printed and handed over — not digitally accepted.</div>
    <div className="ci-def ci-def--wide">
      <span className="ci-def__label">Handed over</span>
      <span className="ci-def__value">{fmt(notice.recordedAt)}</span>
      <span className="ci-def__label">By</span>
      <span className="ci-def__value">{notice.recordedBy}</span>
      <span className="ci-def__label">Reason</span>
      <span className="ci-def__value">
        {notice.reasonCode === 'other' ? notice.reasonText : notice.reasonLabel}
        {notice.reasonCode !== 'other' && notice.reasonText ? ` — ${notice.reasonText}` : ''}
      </span>
      <span className="ci-def__label">Terms version</span>
      <span className="ci-def__value">{notice.termsVersion}</span>
    </div>
  </div>
);
